// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z5Yl","newExpiryDate":"styles_newExpiryDate__2qRkF","footer":"styles_footer__3VWcb"};